import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';

export default function PrivateOutlet() {
  const { isLogged } = useAuthContext();

  return isLogged ? <Outlet /> : <Navigate to="/404" />;
}
